import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';
import GlobalSearch from './index';
import SearchShortcutListener from './SearchShortcutListener';

interface GlobalSearchContextType {
  openSearch: () => void;
  closeSearch: () => void;
  isSearchOpen: boolean;
}

const GlobalSearchContext = createContext<GlobalSearchContextType | undefined>(undefined);

export const GlobalSearchProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const openSearch = useCallback(() => {
    setIsSearchOpen(true);
  }, []);

  const closeSearch = useCallback(() => {
    setIsSearchOpen(false);
  }, []);

  return (
    <GlobalSearchContext.Provider value={{ openSearch, closeSearch, isSearchOpen }}>
      {children}
      {isSearchOpen && <GlobalSearch isOpen={isSearchOpen} onClose={closeSearch} />}
    </GlobalSearchContext.Provider>
  );
};

export const GlobalSearchShortcutProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <>
      {children}
      <SearchShortcutListener />
    </>
  );
};

export const useGlobalSearch = (): GlobalSearchContextType => {
  const context = useContext(GlobalSearchContext);
  if (context === undefined) {
    throw new Error('useGlobalSearch must be used within a GlobalSearchProvider');
  }
  return context;
};

export default GlobalSearchContext;